import { useMemo } from 'react'
import { GLOBE, globeShapes } from './globeShapes'

// The home screen's picture over Go to war: the world from space, your
// territory (yellow) striking theirs (red) under a crosshair.
const C = GLOBE.size / 2
const FILL = { land: '#2b3832', yours: '#c9b52e', theirs: '#b8402f' }
const EDGE = { land: '#3d4d45', yours: '#f0e040', theirs: '#e0604a' }

export default function GlobeArt({ className = '' }) {
    const { hexes, graticule, strike } = useMemo(globeShapes, [])
    const { to } = strike
    return (
        <svg className={`pt-globe ${className}`} viewBox={`0 0 ${GLOBE.size} ${GLOBE.size}`} role="img" aria-label="The globe at war">
            <defs>
                <radialGradient id="pt-globe-sea" cx="38%" cy="32%" r="75%">
                    <stop offset="0%" stopColor="#1c2a33" />
                    <stop offset="100%" stopColor="#080c0f" />
                </radialGradient>
                <radialGradient id="pt-globe-shade" cx="36%" cy="30%" r="72%">
                    <stop offset="55%" stopColor="#000" stopOpacity="0" />
                    <stop offset="100%" stopColor="#000" stopOpacity="0.7" />
                </radialGradient>
                <radialGradient id="pt-globe-halo" cx="50%" cy="50%" r="50%">
                    <stop offset="78%" stopColor="#f0e040" stopOpacity="0" />
                    <stop offset="86%" stopColor="#f0e040" stopOpacity="0.12" />
                    <stop offset="100%" stopColor="#f0e040" stopOpacity="0" />
                </radialGradient>
                <clipPath id="pt-globe-clip"><circle cx={C} cy={C} r={GLOBE.r} /></clipPath>
            </defs>

            <circle cx={C} cy={C} r={GLOBE.r * 1.2} fill="url(#pt-globe-halo)" />
            <circle cx={C} cy={C} r={GLOBE.r} fill="url(#pt-globe-sea)" />
            <g clipPath="url(#pt-globe-clip)">
                {graticule.map((p, i) => <polyline key={i} points={p} fill="none" stroke="#fff" strokeOpacity="0.07" strokeWidth="0.6" />)}
                {hexes.map((h, i) => (
                    <polygon key={i} points={h.points} fill={FILL[h.kind]} fillOpacity={h.kind === 'land' ? 0.9 : 0.75}
                        stroke={EDGE[h.kind]} strokeWidth="0.6" strokeOpacity={0.5 + 0.5 * h.front} />
                ))}
                <circle cx={C} cy={C} r={GLOBE.r} fill="url(#pt-globe-shade)" />
            </g>
            <circle cx={C} cy={C} r={GLOBE.r} fill="none" stroke="#f0e040" strokeOpacity="0.28" strokeWidth="1" />

            <path className="pt-globe__strike" d={strike.path} fill="none" stroke="#f0e040" strokeWidth="1.6" strokeDasharray="4 4" strokeLinecap="round" />
            <circle cx={strike.from.x} cy={strike.from.y} r="2.6" fill="#f0e040" />

            <g transform={`translate(${to.x.toFixed(1)} ${to.y.toFixed(1)})`}>
                <circle className="pt-globe__ping" r="8" fill="none" stroke="#e0604a" strokeWidth="1.4" />
                <circle r="8" fill="none" stroke="#e0604a" strokeWidth="1.4" />
                {[[0, -1], [0, 1], [-1, 0], [1, 0]].map(([x, y], i) => (
                    <line key={i} x1={x * 5} y1={y * 5} x2={x * 13} y2={y * 13} stroke="#e0604a" strokeWidth="1.4" />
                ))}
                <circle r="1.6" fill="#e0604a" />
            </g>
        </svg>
    )
}
